import gql from 'graphql-tag';

export default gql`
mutation deletePageTag($pageId: Int!, $tagId: Int!) {
  delete_pages_tags(where: {page_id: {_eq: $pageId}, tag_id: {_eq: $tagId}}) {
    affected_rows
  }
}
`;
